import { REGISTER_COMPANY } from "../types/RegisterCompanyType";

export const registerCompany =(data)=>({
    type: REGISTER_COMPANY,
    payload: data
})
